import { VTab, VueTabs } from 'vue-nav-tabs'
import AdminPaymentsTab from './payments-tab/payments-tab.vue'
import AdminRefundsTab from './refunds-tab/refunds-tab.vue'
import AdminTransactionTab from './transaction-tab/transaction-tab.vue'
import 'vue-nav-tabs/themes/vue-tabs.scss'
import { EventBus } from '@/services/Event.js';

export default {
    name: 'AdminPayments',
    components: { VueTabs, VTab, AdminPaymentsTab, AdminRefundsTab, AdminTransactionTab },
    data() {
        return {
            isTransactionVisible: false
        }
    },
    computed: {
        oldAppPayment() {
            var host = process.env.url.manegement;
            return host + '/Triathlon/PaymentPage.aspx';
        }
    },
    methods: {
        viewTransaction(paymentId) {
            this.isTransactionVisible = true;
            EventBus.$emit("admin_load_transaction", paymentId);
        },
        hideTransaction(paymentId) {
            this.isTransactionVisible = false;
        },
        setInitialParams() {
            var self = this;
            EventBus.$on("admin_view_transaction", paymentId => { self.viewTransaction(paymentId); });
            EventBus.$on("admin_hide_transaction", paymentId => { self.hideTransaction(); });
            EventBus.$emit("admin_load_transaction", 0);
        }
    },
    created() {
        this.setInitialParams();
    }
}



// WEBPACK FOOTER //
// ./src/components/admin/payments/payments.js